import React, { useState, useEffect } from "react";
import Slider from "react-slick";

import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import CardTopFive from "../../atoms/card-top-five/cardTopFive";

import "./topFiveSlider.scss";

interface TopFiveSliderInter {
  conversations: any;
}

const TopFiveSlider = (props: TopFiveSliderInter) => {
  const [sliderIndexM, setSliderIndexM] = useState(0);
  const [conversationsToShow, setConversationToShow ] = useState(props.conversations);
  const { window, isBrowser } = useBrowserMode();

  sliderIndexM;

  useEffect(() => {
    if (isBrowser) {
      if (window.screen.width < 340) {
        setConversationToShow(props.conversations.slice(0, 5));
      } else if (window.screen.width < 501) {
        setConversationToShow(props.conversations.slice(0, 5));
      } else {
        setConversationToShow(props.conversations)
      }
    }
  }, [props.conversations]);

  const settingsM = {
    className: "center",
    centerPadding: "20%",
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (_: number, next: number) => setSliderIndexM(next),
    responsive: [
      {
        breakpoint: 960,
        settings: {
          centerMode: false,
          slidesToShow: 1.35,
          slidesToScroll: 1, 
        },
      },
    ],
  };

  return (
    <section className="m-top-five-slider">
      <div className="show-on-mobile">
        <Slider {...settingsM}>
          {
            conversationsToShow.map((conversation, idx) => {
              return(
                <CardTopFive
                conversation={conversation}
                number={idx + 1}
                key={idx}
                />
              )
            })
          }
        </Slider>
      </div>
    </section>
  );
};

export default TopFiveSlider;
